import { Button } from '@progress/kendo-react-buttons';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';


export default function ButtonCell(props) {
  const navigate = useNavigate();
  return (
    <td>
      <Button
        onClick={() => {
          navigate(props.dataItem[props.field],
            {
              state: {
                data: props.dataItem,
              }
            }
          );
        }}
      >Ouvrir</Button>
    </td>
  );
}

ButtonCell.propTypes = {
  dataItem: PropTypes.any,
  field: PropTypes.any,
};
